module.exports = __webpack_public_path__ + "static/media/Diamant_2.d5f3ccae.svg";